/* eslint-disable no-empty-label */
import dayjs from 'dayjs'
import { userCache } from '../config/config'
import { StorageList } from '../config/enums'

const DEFAULT_TIME_REG = 'YYYY-MM-DD HH:mm:ss'
const codeStr = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
function getRandom(n, m) {
  return Math.floor(Math.random() * (m - n) + n)
}
export default {
  isJson: function(jsonStr) {
    if (typeof jsonStr === 'string') {
      try {
        JSON.parse(jsonStr)
        return true
      } catch (e) {
        return false
      }
    }
    return false
  },
  storage: () => {
    if (userCache === StorageList.Session) {
      return sessionStorage
    }
    return localStorage
  },
  sessionStorage: () => {
    return sessionStorage
  },
  getTimeWithStamp: (stamp) => {
    return new Date(Number(stamp))
  },
  tunefulParse: (jsonStr, defaultReturn) => {
    if (typeof jsonStr === 'string') {
      try {
        return JSON.parse(jsonStr)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(jsonStr + ' is not a json')
      }
    }
    return defaultReturn || jsonStr
  },
  //根据时间戳和正则格式获取时间
  //格式 形如  'YYYY-MM-DD HH:mm:ss'
  stampFormat(stamp, reg = DEFAULT_TIME_REG) {
    stamp = Number(stamp)
    return dayjs(stamp).format(reg)
  },
  /**
   * @2019-07-22
   * @author: huimingchen
   * @params: time reg
   * desc: 该方法用于任何时间（字符串，dayjs对象 date对象 转成特定格式）
   */
  timeFormat(time, reg = DEFAULT_TIME_REG) {
    if (Number(time)) {
      time = Number(time)
    }
    if (!time) {
      return ''
    }
    return dayjs(time).isValid() ? dayjs(time).format(reg) : ''
  },
  getDateWithTime(time) {
    if (Number(time)) {
      time = Number(time)
    }
    return dayjs(time).isValid() ? dayjs(time).toDate() : ''
  },
  //这个是将一个时间戳转成时间段，最好但是默认为天
  durationFormat(stamp, unit = 'd') {
    let target = parseInt(stamp / (1000 * 60))
    let targetStr = (target % 60) + '分钟'
    target = parseInt(target / 60)
    if (unit === 'd' && target > 24) {
      targetStr = (target % 24) + '小时' + targetStr
      targetStr = parseInt(target / 24) + '天' + targetStr
    } else if (target) {
      targetStr = target + '小时' + targetStr
    }
    return targetStr
  },
  autoFixed(num, fixedLength = 2) {
    let copyNum = num
    if (typeof copyNum === 'string') {
      copyNum = parseFloat(copyNum)
    }
    if (typeof copyNum === 'number' && !isNaN(copyNum)) {
      return copyNum.toFixed(fixedLength)
    }
    return num
  },
  li2yuan(num) {
    if (typeof num === 'string') {
      num = parseFloat(num)
    }
    if (typeof num === 'number' && !isNaN(num)) {
      return num / 1000
    }
    return 0
  },
  yuan2li(num) {
    if (typeof num === 'string') {
      num = parseFloat(num)
    }
    if (typeof num === 'number' && !isNaN(num)) {
      return Math.floor(num * 1000)
    }
    return num
  },
  isFunction(obj) {
    return typeof obj === 'function'
  },
  targetValue(originValue, ...params) {
    if (typeof originValue === 'function') {
      return originValue(...params)
    }
    return originValue
  },
  //比较两个对象是否 '相同' 只比较第一层
  compare(obj, compareObj) {
    if (typeof obj !== 'object' || typeof compareObj !== 'object') {
      return false
    }
    if (Object.keys(obj).length !== Object.keys(compareObj).length) {
      return false
    }

    return !Object.keys(obj).some((keys) => obj[keys] !== compareObj[keys])
  },
  getFullAddress(address) {
    if (address) {
      return address.replace(new RegExp('\\$', 'g'), '')
    }
    return address
  },
  getFullAddress2(address) {
    if (address) {
      return address.replace(new RegExp('\\$', 'g'), '-')
    }
    return address
  },
  getPCAAddress(address) {
    if (address) {
      const addressList = address.split('$')
      addressList.pop()
      return addressList.join('')
    }
    return ''
  },
  getDetailAddress(address) {
    if (address) {
      return address.split('$').pop()
    }
    return ''
  },
  getDetailFullAddress(address) {
    if (address) {
      return address.split('$').join('-')
    }
    return ''
  },
  //比较两个对象不同的 key
  compareDiffKeys(obj, compareObj) {
    if (typeof obj !== 'object') {
      throw new Error('参数错误')
    }
    if (typeof compareObj !== 'object') {
      return Object.keys(obj)
    }
    const diffKeys = []
    Object.keys(obj).forEach((keys) => {
      if (typeof obj[keys] === 'object') {
        !this.compare(obj[keys], compareObj[keys]) && diffKeys.push(keys)
      } else {
        compareObj[keys] !== obj[keys] && diffKeys.push(keys)
      }
    })
    return diffKeys
  },
  //时间戳加 5位随机数
  getRandomCode() {
    let str = '' + new Date().valueOf()
    for (let i = 0; i < 5; i++) {
      let ran = getRandom(0, codeStr.length)
      str += codeStr.charAt(ran)
    }
    return str
  },
  //生成一个指定长度的随机数 这里用于 key的 生成
  getRandomKey(length = 10) {
    let str = ''
    for (let i = 0; i < length; i++) {
      let ran = getRandom(0, codeStr.length)
      str += codeStr.charAt(ran)
    }
    return str
  },
  isPicture(url) {
    let strFilter = '.jpeg|.gif|.jpg|.png|.bmp|.pic|.webp|'
    if (typeof url === 'string' && url.indexOf('.') > -1) {
      let p = url.lastIndexOf('.')
      let strPostfix = url.substring(p, url.length) + '|'
      strPostfix = strPostfix.toLowerCase()
      return strFilter.indexOf(strPostfix) > -1
    }
    return false
  },
  fileExamType(url, type) {
    //type 的传值为 .xxx, .xxxx, .xx
    if (!type) {
      return true
    }
    const typeArr = type.split(', ')
    for (let i = 0; i < typeArr.length; i++) {
      let reg = new RegExp('^.*\\' + typeArr[i] + '$')
      if (reg.test(url)) {
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js